import axios from 'axios';

const apiClient = axios.create({
  // 开发环境通过 Vite 代理转发，避免 CORS；打包环境读取对应 .env 文件里的 API 域名
  baseURL: import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default apiClient;
